import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        fontStyle: 'bold',
    },
    shareholder: {
        width: '20%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 8,
    },
    description: {
        width: '25%',
        textAlign: 'left',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingLeft: 8,
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 8,
    },
    rate: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'right',
        paddingRight: 8,
    },
    amount: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
    },
    owned: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
    },
  });


const CapTableTableRow = ({items}) => {
    const rows = items.map( item => 
        <View style={styles.row} key={item.sno.toString()}>
            <Text style={styles.shareholder}>{item.name}</Text>
            <Text style={styles.description}>{item.capital}</Text>
            <Text style={styles.qty}>{item.common_shares}</Text>
            <Text style={styles.rate}>{item.pref_shares}</Text>
            <Text style={styles.amount}>{item.total_shares}</Text>
            <Text style={styles.owned}>{item.percent_shares}%</Text>
        </View>
    )
    return (<Fragment>{rows}</Fragment> )
};
  
  export default CapTableTableRow